module.exports = __webpack_public_path__ + "static/media/XpressPac-logo-Original.09cb3188.png";